import InputFormTable from './InputFormTable';
export default InputFormTable;
